import { CanActivate, ExecutionContext, ForbiddenException, Injectable } from '@nestjs/common';

const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);

// Applied only to admin/platform/merchant controllers — never to storefront
// routes (cart, checkout, auth, reviews), which must keep working so visitors
// can actually try the demo. Reads still work here too, so a visitor can look
// around the admin panel; only writes are blocked, and only when DEMO_MODE
// is set (a no-op guard in every non-demo deployment).
@Injectable()
export class DemoModeGuard implements CanActivate {
  canActivate(context: ExecutionContext): boolean {
    if (process.env.DEMO_MODE !== 'true') return true;

    const request = context.switchToHttp().getRequest<{ method: string }>();
    if (SAFE_METHODS.has(request.method)) return true;

    throw new ForbiddenException(
      'This is a shared public demo — administrative changes are disabled here.'
    );
  }
}
